"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SelectTrigger = void 0;
var _react = _interopRequireWildcard(require("react"));
require("./SelectTrigger.css");
var _useInputVariant = require("@cbhq/cds-common/hooks/useInputVariant");
var _usePrefixedId2 = require("@cbhq/cds-common/hooks/usePrefixedId");
var _useScaleConditional = require("@cbhq/cds-common/scale/useScaleConditional");
var _select = require("@cbhq/cds-common/tokens/select");
var _HStack = require("../layout/HStack");
var _AnimatedCaret = require("../motion/AnimatedCaret");
var _system = require("../system");
var _TextBody = require("../typography/TextBody");
var _context = require("./context");
var _InputLabel = require("./InputLabel");
var _SelectStack = require("./SelectStack");
const _excluded = ["compact", "placeholder", "disabled", "label", "value", "variant", "triggerHasFocus", "helperText", "onPress", "startNode", "visible"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const pressableOverrides = "cds-pressableOverrides-p1aumb5r";
const SelectTrigger = /*#__PURE__*/(0, _react.memo)( /*#__PURE__*/(0, _react.forwardRef)(function SelectTrigger(_ref, ref) {
  var _ref2;
  let compact = _ref.compact,
    placeholder = _ref.placeholder,
    disabled = _ref.disabled,
    label = _ref.label,
    value = _ref.value,
    variant = _ref.variant,
    triggerHasFocus = _ref.triggerHasFocus,
    helperText = _ref.helperText,
    onPress = _ref.onPress,
    startNode = _ref.startNode,
    visible = _ref.visible,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const _usePrefixedId = (0, _usePrefixedId2.usePrefixedId)(['label', 'description']),
    accessibilityLabelId = _usePrefixedId[0],
    accessibilityDescriptionId = _usePrefixedId[1];
  const focusedVariant = (0, _useInputVariant.useInputVariant)(triggerHasFocus, variant);
  const minHeight = (0, _useScaleConditional.useScaleConditional)(compact ? _select.selectTriggerCompactMinHeight : _select.selectTriggerMinHeight);
  const shouldShowCompactLabel = compact && label;
  // this corrects for when value is initialized with an empty string, coerce it to undefined
  const sanitizedValue = value === '' ? undefined : value;
  return /*#__PURE__*/_react.default.createElement(_SelectStack.SelectStack, {
    ref: ref,
    accessibilityDescriptionId: accessibilityDescriptionId,
    accessibilityLabelId: accessibilityLabelId,
    compact: compact,
    disabled: disabled,
    focused: triggerHasFocus,
    helperText: helperText,
    label: label,
    variant: variant
  }, /*#__PURE__*/_react.default.createElement(_system.PressableOpacity, _extends({
    noScaleOnPress: true,
    className: pressableOverrides,
    onPress: onPress,
    tabIndex: 0,
    width: "100%"
  }, props), /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    minHeight: minHeight,
    minWidth: 0,
    spacingStart: startNode ? 0 : 2,
    width: "100%"
  }, !!startNode && /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    alignItems: "center",
    justifyContent: "center",
    minWidth: 0
  }, startNode), shouldShowCompactLabel ? /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    alignItems: "center",
    maxWidth: "40%",
    spacingEnd: 1
  }, /*#__PURE__*/_react.default.createElement(_InputLabel.InputLabel, {
    color: _select.labelTextColor,
    id: accessibilityLabelId,
    overflow: "truncate"
  }, label)) : null, /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    alignItems: "center",
    borderRadius: "rounded",
    justifyContent: "space-between",
    minWidth: 0,
    spacingVertical: compact ? 1 : 2,
    width: "100%"
  }, /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    flexGrow: 1,
    flexShrink: 1,
    justifyContent: shouldShowCompactLabel ? 'flex-end' : 'flex-start',
    minWidth: 0
  }, /*#__PURE__*/_react.default.createElement(_TextBody.TextBody, {
    align: shouldShowCompactLabel ? 'end' : 'start',
    as: "p",
    color: sanitizedValue ? 'foreground' : 'foregroundMuted',
    overflow: "truncate"
  }, (_ref2 = sanitizedValue !== null && sanitizedValue !== void 0 ? sanitizedValue : placeholder) !== null && _ref2 !== void 0 ? _ref2 : !compact ? label : null)), /*#__PURE__*/_react.default.createElement(_HStack.HStack, {
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_context.TextInputFocusVariantContext.Provider, {
    value: focusedVariant !== null && focusedVariant !== void 0 ? focusedVariant : undefined
  }, /*#__PURE__*/_react.default.createElement(_AnimatedCaret.AnimatedCaret, {
    rotate: visible ? 0 : 180,
    spacingHorizontal: 2
  })))))));
}));
exports.SelectTrigger = SelectTrigger;